function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { addListener } from '@domain-group/fe-helper';
import AvatarIcon from './avatar-icon';
import * as styles from './avatar.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class Avatar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
    this.handleError = this.handleError.bind(this);
  }
  componentDidMount() {
    if (this.props.imageUrl) {
      var img = new Image();
      this.removeListenerError = addListener(img, 'error', this.handleError);
      img.src = this.props.imageUrl;
    }
  }
  componentWillUnmount() {
    if (this.removeListenerError) {
      this.removeListenerError();
    }
  }
  removeListenerError() {}
  handleError() {
    this.setState({
      hasError: true
    });
  }
  render() {
    var avatar = styles.avatarDetails(this.props.shape || Avatar.defaultProps.shape, this.props.size || Avatar.defaultProps.size, this.props.colorScheme || Avatar.defaultProps.colorScheme, this.props.isBordered || Avatar.defaultProps.isBordered);
    if (!this.props.imageUrl || this.state.hasError) {
      return ___EmotionJSX(AvatarIcon, {
        css: avatar,
        className: this.props.className
      });
    }
    return ___EmotionJSX("div", {
      className: this.props.className,
      css: avatar
    }, ___EmotionJSX("img", {
      "data-testid": "fe-co-avatar--image",
      css: styles.avatarImage,
      src: this.props.imageUrl,
      alt: this.props.imageTitle
    }));
  }
}
_defineProperty(Avatar, "defaultProps", {
  shape: 'circle',
  size: 'medium',
  colorScheme: 'dark',
  isBordered: false
});
export default Avatar;